@if (isLoading) {
  <div class="flex justify-center">
    @if (isLoading) {
      <p-progressSpinner />
    }
  </div>
}
<div class="flex justify-between items-center mb-4">
  <div class="flex items-center gap-4">
    <div class="w-21">
      <label class="font-semibold">Search By:</label>
    </div>
    <p-select
      placeholder="Select type"
      class="w-56"
      [options]="searchTypes"
      [(ngModel)]="searchType"
      (onChange)="onChangeSearchType()"
      [disabled]="!tenantId"
      appendTo="body"
    />
    @if (searchType === 'npi') {
      <div>
        <input type="text" class="w-56" pInputText [(ngModel)]="npi" />
      </div>
    }
    @if (searchType === 'company') {
      <div>
        @if (loadingParentCompanies) {
          <p-progressSpinner class="w-12! h-12!" />
        }
        @if (!loadingParentCompanies) {
          <p-select
            placeholder="Select parent company"
            class="w-56"
            panelStyleClass="w-112"
            [pt]="{
              option: {
                class: '[&_span]:max-w-100 [&_span]:truncate',
              },
            }"
            [virtualScroll]="true"
            [virtualScrollItemSize]="36"
            [filter]="true"
            [options]="companies"
            [(ngModel)]="companyName"
            appendTo="body"
          />
        }
      </div>
    }
    <div>
      <button
        pButton
        type="button"
        label="Search"
        [disabled]="disableSearch()"
        (click)="onSearch(searchType)"
      ></button>
    </div>
  </div>

  <div>
    <button
      pButton
      severity="secondary"
      type="button"
      (click)="clearAllFilters()"
      label="Clear All Filters"
      class="mr-2"
      [disabled]="!isLoadingUsers && disabledClearAllButton"
    ></button>
    <button
      pButton
      type="button"
      (click)="onRemove()"
      [disabled]="!userSelectedItems.length || isLoading"
      label="Remove Selected"
    ></button>
  </div>
</div>

<div class="md:grid grid-cols-2 gap-4">
  <div>
    <p-table
      #dtp
      aria-label="Provider table"
      [alwaysShowPaginator]="false"
      class="table-parameters table-simple-paginator"
      [value]="foundProviders"
      [columns]="columns"
      [(selection)]="providerSelectedItems"
      [paginator]="true"
      [sortOrder]="defaultSortOrderProviders"
      [loading]="isLoadingProviders"
      [defaultSortOrder]="defaultSortOrderProviders"
      [sortField]="defaultSortFieldProviders"
      [totalRecords]="foundProvidersTotalRecords"
      [rows]="amountOfRows"
      [lazy]="true"
      (onLazyLoad)="handleLazyLoadProviders($event)"
      (onPage)="onPageChangeProviders()"
      (onRowSelect)="rowSelectProviders()"
      (onRowUnselect)="rowUnselectProviders()"
      [resetPageOnSort]="true"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th class="w-16">
            <p-checkbox
              [binary]="true"
              [disabled]="foundProviders && foundProviders.length === 0"
              [(ngModel)]="selectAllStateProviders"
              (onChange)="onChangeSelectAllStateProviders($event)"
            />
          </th>
          @for (col of columns | slice:0:-1; track col) {
            <th
              [ngStyle]="{ display: col.display }"
              [pSortableColumn]="unsortedFields.includes(col.field) ? '' : col.field"
              [pSortableColumnDisabled]="unsortedFields.includes(col.field)"
            >
              <div class="flex items-center gap-2">
                {{ col.header }}
                @if (!unsortedFields.includes(col.field) && col.header !== '') {
                  <p-sortIcon
                    [field]="col.field"
                    aria-label="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                  >
                  </p-sortIcon>
                }
              </div>
            </th>
          }
        </tr>
        <tr class="header-filter">
          <th class="w-16"></th>
          <th>
            <p-multiSelect
              #providerListMs
              class="max-w-64"
              [options]="providerNameListProviders"
              (onChange)="filterTableProviders($event.value, 'providerName', 'in')"
              [(ngModel)]="providerNameFilter"
              placeholder="Filter"
              [disabled]="!searchTypeCurrent"
              appendTo="body"
            />
          </th>
          <th>
            <p-select
              placeholder="Filter"
              class="max-w-64"
              [options]="activeStateListProviders"
              [showClear]="true"
              (onChange)="filterTableProviders($event.value, 'isActive', 'eq')"
              [(ngModel)]="provideActiveFilter"
              [disabled]="!searchTypeCurrent"
              appendTo="body"
            />
          </th>
          <th>
            <p-multiSelect
              #providerAddressMs
              class="max-w-64"
              [options]="providerAddressListProviders"
              (onChange)="filterTableProviders($event.value, 'providerAddress', 'in')"
              [(ngModel)]="providerAddressListFilter"
              placeholder="Filter"
              [disabled]="!searchTypeCurrent"
              appendTo="body"
            />
          </th>
          <th>
            <p-multiSelect
              #providerNpiMs
              class="max-w-64"
              [options]="npiListProviders"
              (onChange)="filterTableProviders($event.value, 'npi', 'in')"
              [(ngModel)]="provideNpiFilter"
              placeholder="Filter"
              [disabled]="!searchTypeCurrent"
              appendTo="body"
            />
          </th>
          <th>
            <p-multiSelect
              #providerTaxIdMs
              class="max-w-64"
              [options]="taxIdListProviders"
              (onChange)="filterTableProviders($event.value, 'taxId', 'in')"
              [(ngModel)]="provideTaxIdFilter"
              placeholder="Filter"
              [disabled]="!searchTypeCurrent"
              appendTo="body"
            />
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="6">
            No record found
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr [pSelectableRow]="item" class="[&_td]:max-w-56 [&_td]:truncate">
          <td class="w-16">
            <p-tableCheckbox [value]="item" />
          </td>
          <td>{{ item.providerName }}</td>
          <td>{{ item.isActive ? 'Active' : 'Inactive' }}</td>
          <td>
            <span [title]="item?.providerAddress" >
              {{ item.providerAddress }}
            </span>
          </td>
          <td>{{ item.npi }}</td>
          <td>{{ item.taxId }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="flex gap-4">
    <div class="mt-12">
      <p-button
        type="button"
        icon="pi pi-angle-right"
        (click)="shouldDisplayWarningMessageForHomeHealth()"
        [disabled]="disableAssignButton() || isLoading"
      />
    </div>
    <p-table
      #dtu
      aria-label="Provider users table"
      class="table-parameters table-simple-paginator w-[calc(100%-56px)]"
      dataKey="userTenantMapId"
      [alwaysShowPaginator]="false"
      [value]="userProviders"
      [columns]="columns"
      [(selection)]="userSelectedItems"
      [paginator]="true"
      [sortOrder]="defaultSortOrder"
      [sortField]="defaultSortField"
      [loading]="isLoadingUsers"
      [defaultSortOrder]="defaultSortOrder"
      [totalRecords]="userProvidersTotalRecords"
      [rows]="amountOfRows"
      [lazy]="true"
      (onLazyLoad)="handleLazyLoadUserProviders($event)"
      (onPage)="onPageChangeUserProviders()"
      (onRowSelect)="rowSelectUsers()"
      (onRowUnselect)="rowUnselectUsers()"
      [resetPageOnSort]="true"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th class="w-16">
            <p-checkbox
              [binary]="true"
              [disabled]="userProviders && userProviders.length === 0"
              [(ngModel)]="selectAllStateUserProviders"
              (onChange)="onChangeSelectAllStateUserProviders($event)"
            >
            </p-checkbox>
          </th>
          @for (col of columns; track col) {
            <th
              [pSortableColumn]="unsortedFields.includes(col.field) ? '' : col.field"
              [pSortableColumnDisabled]="unsortedFields.includes(col.field)"
            >
              <div class="flex items-center gap-2">
                {{ col.header }}
                @if (!unsortedFields.includes(col.field) && col.header !== '') {
                  <p-sortIcon
                    [field]="col.field"
                    aria-label="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                  />
                }
              </div>
            </th>
          }
        </tr>
        <tr class="header-filter">
          <th class="w-16"></th>
          <th>
            <p-multiSelect
              #userProvidersMs
              class="max-w-64"
              [options]="providerNameList"
              (onChange)="filterTableUserProviders($event.value, 'providerName', 'in')"
              [(ngModel)]="userProviderNameFilter"
              placeholder="Filter"
              [disabled]="disableUserProviderFilters()"
              appendTo="body"
            />
          </th>
          <th>
            <p-select
              #userStateListMs
              class="max-w-64"
              placeholder="Filter"
              [options]="activeStateList"
              [showClear]="true"
              (onChange)="filterTableUserProviders($event.value, 'isActive', 'eq')"
              [(ngModel)]="userActiveFilter"
              [disabled]="disableUserProviderFilters()"
              appendTo="body"
            />
          </th>
          <th>
            <p-multiSelect
              #userAddressMs
              class="max-w-64"
              [options]="providerAddressList"
              (onChange)="filterTableUserProviders($event.value, 'providerAddress', 'in')"
              [(ngModel)]="userProviderAddressListFilter"
              placeholder="Filter"
              [disabled]="disableUserProviderFilters()"
              appendTo="body"
            />
          </th>
          <th>
            <p-multiSelect
              #userNpiMs
              class="max-w-64"
              [options]="npiList"
              (onChange)="filterTableUserProviders($event.value, 'npi', 'in')"
              [(ngModel)]="userNpiFilter"
              placeholder="Filter"
              [disabled]="disableUserProviderFilters()"
              appendTo="body"
            />
          </th>
          <th>
            <p-multiSelect
              #userTaxIdMs
              class="max-w-64"
              [options]="taxIdList"
              (onChange)="filterTableUserProviders($event.value, 'taxId', 'in')"
              [(ngModel)]="userTaxIdFilter"
              placeholder="Filter"
              [disabled]="disableUserProviderFilters()"
              appendTo="body"
            />
          </th>
          <th>
            <p-multiSelect
              #accountMs
              class="max-w-64"
              [options]="healthPlanList"
              (onChange)="filterTableUserProviders($event.value, 'tenantName', 'in')"
              [(ngModel)]="userTenantNameListFilter"
              placeholder="Filter"
              [showHeader]="false"
              [disabled]="disableUserProviderFilters()"
              appendTo="body"
            />
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="7">
            <p class="p-my-2">No record found</p>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr [pSelectableRow]="item" class="[&_td]:max-w-56 [&_td]:truncate">
          <td class="w-16">
            <p-tableCheckbox [value]="item" />
          </td>
          <td>{{ item.providerName }}</td>
          <td>{{ item.isActive ? 'Active' : 'Inactive' }}</td>
          <td>{{ item.providerAddress }}</td>
          <td>{{ item.npi }}</td>
          <td>{{ item.taxId }}</td>
          <td>{{ item.tenantName }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-confirmDialog
  header="Confirmation"
  icon="pi pi-exclamation-triangle"
  appendTo="body"
  key="confirmRemoved"
/>
<p-confirmDialog
  header="Confirmation"
  appendTo="body"
  key="parentCompanyValidationForHH"
  [style]="{width:'28vw'}"
/>
<p-toast key="removed" position="bottom-left"/>
<p-toast key="error" position="bottom-left"/>
<p-toast key="success" position="bottom-left"/>
